<template>
    <div class="insurance-company-list">
        <el-table :data="list">
            <el-table-column width="50">
                <template slot-scope="scope">
                    <el-radio :disabled="scope.row.disabled" v-model="currentRow"
                    :label="scope.$index"
                    class="radio-hide-label"
                    ></el-radio>
                </template>
            </el-table-column>
            <el-table-column label="保司" prop="insuranceCompany"></el-table-column>
            <el-table-column label="总保费" prop="totalInsuranceCost">
                <template slot-scope="scope">
                    {{ convertNumber(scope.row.totalInsuranceCost) }}
                </template>
            </el-table-column>
            <el-table-column
            label="商业保险费" prop="commercialInsuranceCost">
                <template slot-scope="scope">
                    {{ convertNumber(scope.row.commercialInsuranceCost) }}
                </template>
            </el-table-column>
            <el-table-column
            label="商业险起保日期"
            prop="commercialInsuranceStartTime"></el-table-column>
            <el-table-column
            label="交强险保费"
            prop="compulsoryInsuranceCost">
                <template slot-scope="scope">
                    {{ convertNumber(scope.row.compulsoryInsuranceCost) }}
                </template>
            </el-table-column>
            <el-table-column
            label="交强险起保日期"
            prop="compulsoryInsuranceStartTime"></el-table-column>
            <el-table-column
            label="车船税"
            prop="vavTax">
                <template slot-scope="scope">
                    {{ convertNumber(scope.row.vavTax) }}
                </template>
            </el-table-column>
            <el-table-column
            label="明细图片"
            prop="picture"
            >
            <template slot-scope="scope">
                <el-button
                v-if="scope.row.picture"
                type="text"
                @click="previewImg(scope.row)"
                >预览图片</el-button>
                <span v-else>--</span>
            </template>
        </el-table-column>
            <el-table-column
            label="核保结果"
            prop="underwritingResult"></el-table-column>
        </el-table>
        <ImageView
            :imgViewShow="imageView.show"
            :imgList="[imageView.img]"
            @closeImgView="imageView.show = false"
        />
    </div>
</template>

<script setup>
import { ref, toRefs, watchEffect } from 'vue'
import { convertNumber } from '@/utils'
import ImageView from '@/components/UploadCommon/components/ImageView.vue'
import { UNDERWRITE_STATE, ORDER_STATUS_MAP } from '../../enum'


const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  orderStatus: {
    type: Number,
    default: 0,
  },
})

const { list, orderStatus } = toRefs(props)


const currentRow = ref(0)

const imageView = ref({
  show: false,
  img: '',
})

const getCurrentRow = () => {
  if ([ORDER_STATUS_MAP.WAIT_TO_PAY, ORDER_STATUS_MAP.WAIT_PAY_CONFIRM].includes(orderStatus)) {
    const underwritingSucc =
        list.value.find((item) => item.underwritingState === UNDERWRITE_STATE.SUCCESS)
    if (underwritingSucc) {
      currentRow.value = list.value.findIndex((item) => item.id === underwritingSucc.id)
    }
  }
}

const previewImg = (row) => {
  imageView.value.img = row.picture
  imageView.value.show = true
}

watchEffect(() => {
  getCurrentRow()
})


</script>

<style lang="scss" scoped>
.radio-hide-label {
  ::v-deep .el-radio__label {
    display: none;
  }
}
</style>
